import React from 'react';
import { Card, CardContent, Typography, Box } from '@mui/material';
import PropTypes from 'prop-types';

const SuggestionsCard = ({ daySummary }) => {
  if (!daySummary) {
    return null;
  }

  const renderSuggestion = (suggestion) => {
    // Patterns for extracting "FROM ... TO ..." and "TO ..." parts
    const fromToPattern = /from hours: \[(.*?)\] to \[(.*?)\](.*)/;
    const toPattern = /to \[(.*?)\](.*)/;

    if (fromToPattern.test(suggestion)) {
      const [, fromHours, toHours, remainingText] = suggestion.match(fromToPattern);

      return (
        <>
          <Typography variant="body2" color="textSecondary" gutterBottom>
            {suggestion.split("from hours")[0].trim()}
          </Typography>
          <Typography variant="body2" color="textSecondary" gutterBottom>
            <strong>FROM</strong> {fromHours}
          </Typography>
          <Typography variant="body2" color="textSecondary" gutterBottom>
            <strong>TO</strong> {toHours}
          </Typography>
          <Typography variant="body2" color="textSecondary">
            {remainingText.trim()}
          </Typography>
        </>
      );
    } else if (toPattern.test(suggestion)) {
      const [, toHours, remainingText] = suggestion.match(toPattern);

      return (
        <>
          <Typography variant="body2" color="textSecondary" gutterBottom>
            {suggestion.split("to")[0].trim()}
          </Typography>
          <Typography variant="body2" color="textSecondary" gutterBottom>
            <strong>TO</strong> {toHours}
          </Typography>
          <Typography variant="body2" color="textSecondary">
            {remainingText.trim()}
          </Typography>
        </>
      );
    } else {
      // Fallback for no match
      return <Typography variant="body2" color="textSecondary">{suggestion}</Typography>;
    }
  };

  return (
    <Card
      sx={{
        boxShadow: 0,
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 2,
        height: '100%',
      }}
    >
      <CardContent>
        <Typography variant="h5" fontWeight="bold" gutterBottom>
          Daily Suggestions
        </Typography>

        <Typography variant="h6" fontWeight="bold" gutterBottom>
          {daySummary.date}
        </Typography>

        <Typography variant="subtitle1" fontWeight="bold">
          Dominant Period:
        </Typography>
        <Typography variant="body2" color="textSecondary" gutterBottom>
          {daySummary.dominant_period}
        </Typography>

        <Typography variant="subtitle1" fontWeight="bold">
          Suggestions:
        </Typography>
        {daySummary.suggestions.map((suggestion, idx) => (
          <Box key={idx}>{renderSuggestion(suggestion)}</Box>
        ))}
      </CardContent>
    </Card>
  );
};

SuggestionsCard.propTypes = {
  daySummary: PropTypes.shape({
    date: PropTypes.string.isRequired,
    dominant_period: PropTypes.string.isRequired,
    suggestions: PropTypes.arrayOf(PropTypes.string).isRequired,
  }),
};

export default SuggestionsCard;
